

export default function getMaxTextWidth (texts, fontSize) {
  let div = document.createElement('div');
  document.body.appendChild(div);

  div.style.fontSize = fontSize;
  div.style.position = 'absolute';
  div.style.left = '-5000px';
  div.style.top = '-5000px';

  let maxWidth = 0;

  texts.forEach((text) => {
    div.textContent = text;
    const width = div.clientWidth;
    if (width && width > maxWidth) {
      maxWidth = width;
    }
  });

  document.body.removeChild(div);
  div = null;

  return maxWidth;
}
